import * as React from 'react';
import styles from './Title.module.css';
export default function Title(_a) {
    var text = _a.text, style = _a.style;
    return (React.createElement("div", { className: styles.title, style: style }, text));
}
